// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1Ar3b","text":"SelectPayment_text__2yyZU","title":"SelectPayment_title__248MM","btn":"SelectPayment_btn__2R-_U"};